import { FC } from 'react';
import styles from './styles.module.scss';
import { CatListItem } from '@blocks-react/components/ListItem';

interface ListWithIconsItemProps {
  className?: string;
  icon: React.ReactNode;
  text: string;
  background?: boolean;
  hover?: boolean;
}

export const ListWithIconsItem: FC<ListWithIconsItemProps> = ({
  className,
  icon,
  text,
  background = false,
  hover = false,
}) => (
  <CatListItem className={className} isStatic={!hover}>
    <div className="d-flex align-items-center">
      <div
        className={`${styles['icon__container']} ${
          background ? styles['icon__bg--circle'] : ''
        }`}
      >
        {icon}
      </div>
      <div className="cat-u-theme-typography-display-sm">{text}</div>
    </div>
  </CatListItem>
);
